// extracted by mini-css-extract-plugin
export default {"title":"ProjectCard-module--title--5XFvl","image":"ProjectCard-module--image--3lqZD"};